import { MoviePlayIcon } from './MoviePlayIcon';

/**
 * author: Colton Wiscombe
 * id 44B019DA-A010-4B5F-AF03-61DBCC6206DD
 * name movie-play
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-play.svg
 * tags
 * - Video / Movie 
 */
export const FilmPlayIcon = MoviePlayIcon;
export default FilmPlayIcon